(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["article-body"] && !Shopify.designMode) return;
  try {
    // Shopify concatene le JS de tous les blocs dans un seul fichier : deux blocs
  // qui declarent la meme fonction au premier niveau se marchent dessus en
  // silence. D'ou l'IIFE, et l'exposition unique sur window que article-toc
  // reutilise au lieu de redeclarer.
  (function () {
    if (window.mcAnchorHeadings) return;

    function slugify(value) {
      return value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60);
    }

    // Idempotent : article-toc et article-body tournent sur DOMContentLoaded
    // sans ordre garanti, le premier arrive pose les ancres, le second n'a
    // rien a faire.
    window.mcAnchorHeadings = function (root) {
      if (!root) return [];
      var headings = root.querySelectorAll('h2, h3');
      for (var i = 0; i < headings.length; i++) {
        var heading = headings[i];
        if (heading.id) continue;
        var base = slugify(heading.textContent || '') || 'section';
        var candidate = base;
        var n = 2;
        while (document.getElementById(candidate)) {
          candidate = base + '-' + n;
          n++;
        }
        heading.id = candidate;
      }
      return headings;
    };
  })();

  document.addEventListener('DOMContentLoaded', function () {
    var body = document.querySelector('[data-mc-article-body]');
    if (!body) return;

    var headings = window.mcAnchorHeadings(body);
    var copyLabel = body.getAttribute('data-copy-label') || 'Copier le lien';
    var copiedLabel = body.getAttribute('data-copied-label') || 'Lien copie';

    for (var i = 0; i < headings.length; i++) {
      (function (heading) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mc-anchor';
        btn.textContent = '#';
        btn.setAttribute('aria-label', copyLabel);
        btn.setAttribute('title', copyLabel);

        btn.addEventListener('click', function () {
          var url = location.origin + location.pathname + '#' + heading.id;
          var done = function () {
            btn.setAttribute('data-copied', 'true');
            btn.setAttribute('aria-label', copiedLabel);
            btn.setAttribute('title', copiedLabel);
            setTimeout(function () {
              btn.removeAttribute('data-copied');
              btn.setAttribute('aria-label', copyLabel);
              btn.setAttribute('title', copyLabel);
            }, 1600);
          };
          // clipboard n'existe pas hors contexte securise : on retombe sur le
          // changement de hash, qui met au moins l'URL dans la barre.
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(done, function () {
              location.hash = heading.id;
            });
          } else {
            location.hash = heading.id;
          }
        });

        heading.appendChild(btn);
      })(headings[i]);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["article-toc"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var nav = document.querySelector('[data-mc-toc]');
    if (!nav) return;

    var body = document.querySelector('[data-mc-article-body]');
    if (!body) return;

    if (window.mcAnchorHeadings) window.mcAnchorHeadings(body);

    var headings = body.querySelectorAll(nav.getAttribute('data-levels') || 'h2');
    var min = parseInt(nav.getAttribute('data-min-headings'), 10) || 0;
    if (headings.length < min) return;

    var list = nav.querySelector('[data-ref="list"]');
    var links = [];
    var targets = [];

    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      // textContent ramasserait aussi le bouton d'ancre ajoute par
      // article-body : on lit le premier noeud texte du titre.
      var label = '';
      for (var k = 0; k < heading.childNodes.length; k++) {
        if (heading.childNodes[k].nodeType === 3) label += heading.childNodes[k].textContent;
      }
      label = label.trim();
      if (!label || !heading.id) continue;

      var item = document.createElement('li');
      if (heading.tagName.toLowerCase() === 'h3') item.className = 'mc-toc__sub';

      var link = document.createElement('a');
      link.setAttribute('href', '#' + heading.id);
      link.textContent = label;

      item.appendChild(link);
      list.appendChild(item);
      links.push(link);
      targets.push(heading);
    }

    if (links.length < min) return;

    if (nav.getAttribute('data-collapse-mobile') === 'true' && window.matchMedia('(max-width: 750px)').matches) {
      var box = nav.querySelector('[data-ref="box"]');
      if (box) box.removeAttribute('open');
    }

    nav.removeAttribute('hidden');

    if (nav.getAttribute('data-track') !== 'true' || !window.IntersectionObserver) return;

    var visible = {};

    var observer = new IntersectionObserver(
      function (entries) {
        for (var j = 0; j < entries.length; j++) {
          visible[entries[j].target.id] = entries[j].isIntersecting;
        }
        var currentIndex = -1;
        for (var t = 0; t < targets.length; t++) {
          if (visible[targets[t].id]) { currentIndex = t; break; }
        }
        // Aucune section visible dans la bande haute : on garde la derniere
        // franchie plutot que de tout eteindre, sinon le repere clignote entre
        // deux titres.
        if (currentIndex === -1) {
          for (var u = targets.length - 1; u >= 0; u--) {
            if (targets[u].getBoundingClientRect().top < 0) { currentIndex = u; break; }
          }
        }
        for (var l = 0; l < links.length; l++) {
          if (l === currentIndex) links[l].setAttribute('aria-current', 'true');
          else links[l].removeAttribute('aria-current');
        }
      },
      { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
    );

    for (var m = 0; m < targets.length; m++) observer.observe(targets[m]);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["blog-index"] && !Shopify.designMode) return;
  try {
    /* L'etat vit dans les radios, pas ici. Ce script ne fait que le refleter
     dans l'URL, ce qui rend une vue filtree partageable, et relire l'URL au
     chargement. replaceState n'empile rien : le bouton retour quitte la page,
     il ne defait pas un filtre. Le retirer ne casse ni le filtre ni le tri. */
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-mc-journal]');
    if (!root) return;

    var radios = root.querySelectorAll('.mc-jr');
    if (!radios.length) return;

    function apply() {
      var params = new URLSearchParams(window.location.search);
      var cat = params.get('cat');
      var tri = params.get('tri');

      for (var i = 0; i < radios.length; i++) {
        var r = radios[i];
        if (cat && r.hasAttribute('data-handle') && r.getAttribute('data-handle') === cat) {
          r.checked = true;
        }
        if (tri && r.getAttribute('data-sort') === tri) {
          r.checked = true;
        }
      }
    }

    function sync() {
      var params = new URLSearchParams(window.location.search);
      var checkedCat = root.querySelector('.mc-jr[data-handle]:checked');
      var checkedSort = root.querySelector('.mc-jr[data-sort]:checked');

      if (checkedCat && checkedCat.getAttribute('data-handle')) {
        params.set('cat', checkedCat.getAttribute('data-handle'));
      } else {
        params.delete('cat');
      }

      if (checkedSort && checkedSort.getAttribute('data-sort') === 'pop') {
        params.set('tri', 'pop');
      } else {
        params.delete('tri');
      }

      var query = params.toString();
      var url = window.location.pathname + (query ? '?' + query : '');
      window.history.replaceState(null, '', url);
    }

    apply();

    for (var j = 0; j < radios.length; j++) {
      radios[j].addEventListener('change', sync);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
